import { render } from "./ImagePreviewModal.vue?vue&type=template&id=2de1a8d6&ts=true"
import script from "./ImagePreviewModal.vue?vue&type=script&lang=ts"
export * from "./ImagePreviewModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__